import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Controller, useForm } from "react-hook-form";

import { INewReceptionSubscription } from "../../../../core/api/responsecenters/types";
import { Row, Spacer } from "../../../../components/Layout/Layout";
import { createARCSubscription } from "../../../../core/api/responsecenters/responsecenters";

import TextInput from "../../../../ui-lib/components/Inputs/TextInput";
import useUser from "../../../../core/user/useUser";
import { notify } from "../../../../ui-lib/components/Alerts/Toast";
import PrimeModal from "../../../../ui-lib/components/PrimeModal/PrimeModal";
import { notifyApiErrors } from "../../../../core/helpers/helpers";

const CreateSubscriptionModal = ({
  isOpen,
  arcId,
  onClose,
  onSibmit,
}: {
  isOpen: boolean;
  arcId: number;
  onClose: () => void;
  onSibmit: (id: number) => void;
}) => {
  const { t } = useTranslation();
  const { authenticatedRequest } = useUser();

  const [isLoading, setIsLoading] = useState(false);

  const {
    control,
    formState: { errors },
    handleSubmit,
  } = useForm<INewReceptionSubscription>();

  const onCreateArcSubscription = async (values: INewReceptionSubscription) => {
    setIsLoading(true);
    try {
      const response = await createARCSubscription(
        authenticatedRequest,
        arcId,
        values
      );
      notify({ message: t("AlarmReceptions:subscription_created") });
      onSibmit(response.data);
    } catch (error: any) {
      notifyApiErrors(error.response?.data.errors);
    } finally {
      setIsLoading(false);
      onClose();
    }
  };

  return (
    <PrimeModal
      withFooter
      withHeader
      header={t("AlarmReceptions:add_new_subscription")}
      isOpen={isOpen}
      onClose={onClose}
      loading={isLoading}
      fixedWidth="848px"
      submitBtn={{
        text: t("AlarmReceptions:create_subscription"),
        onClick: handleSubmit(onCreateArcSubscription),
      }}
      cancelBtn={{
        text: t("Common:cancel"),
        onClick: onClose,
      }}
    >
      <Spacer size={16} />
      {/* prevent submit form on Enter press */}
      <form onSubmit={(e) => e.preventDefault()}>
        <Row type="space">
          <Controller
            name="description"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <TextInput
                required
                label={t("Common:name")}
                placeholder={t("AlarmReceptions:subscription_name_placeholder")}
                value={field.value}
                onChange={field.onChange}
                validationError={
                  errors?.description && t("Errors:input_organization_name")
                }
              />
            )}
          />
        </Row>
      </form>
    </PrimeModal>
  );
};

export default CreateSubscriptionModal;
